import React from 'react'

export const MainTitle = ({children}) => (
    <h1 className='font-bold text-3xl text-center uppercase pt-8'>{children}</h1>
)